import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KrakenToggleComponent } from './kraken-toggle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [KrakenToggleComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [KrakenToggleComponent]
})
export class KrakenToggleModule { }
